import ExclamationCircleOutlined from '@ant-design/icons/ExclamationCircleOutlined';
import Button from 'antd/es/button';
import Typography from 'antd/es/typography';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { styled, useTheme } from 'styled-components';

const { Title, Text } = Typography;

const ErrorContainer = styled.div`
  ${({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${theme.screenXS / 1.2}px;
  text-align: center;
  padding: ${theme.paddingXL}px ${theme.paddingMD}px;
`}
`;

const ErrorIcon = styled.div`
  ${({ theme }) => `
  font-size: ${theme.fontSizeHeading1 * 1.7}px;
  color: ${theme.colorError || '#ff4d4f'};
  margin-bottom: ${theme.marginLG}px;
`}
`;

interface ErrorPageProps {
  title?: string;
  message?: string;
  showBackButton?: boolean;
  backButtonText?: string;
  onBack?: () => void;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Please try again or contact support if the problem persists.',
  showBackButton = true,
  backButtonText = 'Go Back',
  onBack,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      void navigate(-1);
    }
  };

  return (
    <ErrorContainer>
      <ErrorIcon>
        <ExclamationCircleOutlined />
      </ErrorIcon>
      <Title level={3} style={{ marginBottom: `${theme.margin}px` }}>
        {title}
      </Title>
      <Text
        type="secondary"
        style={{
          marginBottom: `${theme.marginXL}px`,
          maxWidth: `${theme.controlHeightLG * 12.5}px`,
        }}
      >
        {message}
      </Text>
      {showBackButton && (
        <Button type="primary" onClick={handleBack}>
          {backButtonText}
        </Button>
      )}
    </ErrorContainer>
  );
};

export default ErrorPage;
